import { createUseStyles } from 'react-jss';
import { colors } from '@insurancemenu/imenu-components-lib';
import { ComponentStylesProps } from '@insurancemenu/imenu-components-lib/dist/types';

const styles: ComponentStylesProps<boolean> = {
  tag: (isTerminated) => ({
    position: 'absolute',
    margin: 0,
    width: '100%',
    top: '-0.1rem',
    left: 0,
    padding: '0.8rem 0',
    color: colors.neutral.white,
    fontSize: '1.4rem',
    textAlign: 'center',
    lineHeight: '2rem',
    borderRadius: '1.5rem 1.5rem 0 0',
    backgroundColor: isTerminated ? colors.red[400] : colors.blue[500],
  }),
};

const createStyles = createUseStyles(styles);
export { createStyles };
